import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import * as styles from 'dygl/build/styles.css';
class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className={styles.fx} alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
         <div className = {styles.typography__h1}> Hello im in here all here test </div>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js